import { bookingInquiryApis, BookingInquiryGetQuery } from '@apis/bookingInquiryApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useBookingInquiryList = createUseQuery(
  (query: BookingInquiryGetQuery) => ['/booking-inquiry/', query],
  (query) => () =>
    bookingInquiryApis
      .get('/booking-inquiry/', {
        query,
      })
      .then((r) => r[200]!),
);
